import {useEffect, useState} from "react";

export const usePageVisible = (): boolean => {
    const [visible, setVisible] = useState(() => document.visibilityState === 'visible');

    useEffect(() => {
        const handleVisibilityChange = () => setVisible(document.visibilityState === 'visible');

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, []);

    return visible;
};

/** The current time, updated every second while mounted - drives the expiry countdown. */
export const useNow = (): number => {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(id);
    }, []);

    return now;
};
